import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";

import { Editor } from "@tinymce/tinymce-react";

import _API from "@util/api";

const TinyMCEEditor = (props) => {
    const { content, height, onChange } = props;

    const [isUploading, setIsUploading] = useState(false);

    const editorRef = useRef(null);

    const handleOnImageUpload = async (callback, value, meta) => {
        const aws = await _API.loadUploadKeys().then((res) => res.data);
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        if (meta.filetype == "image") {
            input.setAttribute("accept", "image/*");
        }

        input.addEventListener("change", (e) => {
            const file = e.target.files[0];

            const reader = new FileReader();
            reader.addEventListener("load", async () => {
                setIsUploading(true);

                if (file.size > 0) {
                    if (file.size > 1024 * 1024 * 10) {
                        swal({ title: "알림", text: "10MB 이하의 파일을 선택해 주세요." });
                        setIsUploading(false);
                        return;
                    }

                    const req = { aws, file, prefix: "TM" };

                    await _API
                        .upload(req)
                        .then((res) => res.data)
                        .then((data) => {
                            const { url, signedUrl } = data;
                            callback(url, { alt: file.name });
                        })
                        .catch((e) => {
                            swal({ title: "알림", text: e.message });
                        });
                }

                setIsUploading(false);
            });
            reader.readAsDataURL(file);
        });

        input.click();
    };

    const handleOnChange = (content) => {
        onChange && onChange(content, editorRef?.current?.plugins.wordcount.getCount());
    };

    return (
        <Editor
            apiKey="mb9tndip82cf9jw9gpaze2tgbc7nd0wer1pf83pdty9b8wlz"
            onInit={(evt, editor) => (editorRef.current = editor)}
            value={content || ""}
            onEditorChange={handleOnChange}
            init={{
                paste_as_text: true,
                height: height || 400,
                menubar: false,
                font_family_formats:
                    "Noto Sans KR=Noto Sans KR;굴림=굴림;궁서=궁서;돋움=돋움;명조=명조;Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                font_size_formats: "12px 14px 16px 18px 24px 30px 36px 48px 60px 72px 96px",
                plugins: "anchor autolink charmap code codesample emoticons image link lists media searchreplace table visualblocks wordcount",
                toolbar: "bold italic underline strikethrough superscript subscript | addcomment showcomments | numlist bullist indent outdent | charmap removeformat",
                content_style: "body { font-size:16px;font-family: Noto Sans KR; }",
                block_unsupported_drop: true,
                automatic_uploads: true,
                file_browser_callback_types: "image",
                images_upload_url: "",
                file_picker_callback: handleOnImageUpload,
            }}
        />
    );
};

export default TinyMCEEditor;
